export default __webpack_public_path__ + "static/media/allery-2.8f1583e8.svg";